import { defineMessages } from 'react-intl';

const messages = defineMessages({
  modalHeader: {
    description: 'Products Grid AutoSplit Modal Header',
    defaultMessage: 'Apply Auto-split Option',
    id: 'bvizdD',
  },
  bulkApplyMessage: {
    description: 'Products Grid AutoSplit Bulk Apply Message',
    defaultMessage: 'This update applies to <b>{count}</b> {count, plural, one {product} other {products}}',
    id: 'pZv6nK',
  },
  cancel: {
    description: 'Products Grid AutoSplit Modal Cancel Button',
    defaultMessage: 'Cancel',
    id: 'CZe6Tp',
  },
  save: {
    description: 'Products Grid AutoSplit Modal Save Button',
    defaultMessage: 'Update Selection',
    id: 'NEB0Jb',
  },
  failureTitle: {
    description: 'Products Grid AutoSplit Error Modal Title',
    defaultMessage: 'Failed to update',
    id: 'UsB6Fd',
  },
  failureMessage: {
    description: 'Products Grid AutoSplit Error Modal Message',
    defaultMessage: 'Failed to apply the update. Please try again.',
    id: '8Oxa9C',
  },
});

export default messages;
